// src/components/About.js
import { FaUserTie } from "react-icons/fa";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const skills = [
  "React.js",
  "Next.js",
  "Tailwind CSS",
  "Node.js",
  "Express.js",
  "MongoDB",
  "MySQL",
  "PHP",
  "Ant Design",
  "Chakra UI",
];

const stats = [
  { value: "10+", label: "Years Experience" },
  { value: "2", label: "Products Built" },
  { value: "10+", label: "Technologies" },
];

export default function About() {
  const ref = useRef();

  useEffect(() => {
    gsap.fromTo(
      ref.current,
      { opacity: 0, y: 60 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
          trigger: ref.current,
          start: "top 80%",
        },
      }
    );
  }, []);

  return (
    <section
      id="about"
      className="relative min-h-screen flex items-center overflow-hidden bg-white border-t border-gray-200 px-6 py-20"
    >
      <div className="pointer-events-none absolute -top-16 -right-16 w-72 h-72 bg-indigo-100/60 rounded-full blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -left-16 w-64 h-64 bg-purple-100/60 rounded-full blur-3xl" />

      <div ref={ref} className="relative z-10 max-w-3xl mx-auto text-center">
        <span className="inline-block text-xs md:text-sm font-semibold tracking-widest uppercase text-indigo-700 bg-indigo-50 px-4 py-1.5 rounded-full shadow-sm mb-5">
          Get to know me
        </span>

        <FaUserTie className="text-4xl md:text-5xl mx-auto mb-6 text-indigo-800" />
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900">
          About Me
        </h2>
        <p className="text-base md:text-xl leading-relaxed text-gray-700 mb-10">
          I'm a seasoned Front-End Developer with a strong foundation in HTML, CSS,
          JavaScript, and expertise in React, Next.js, Tailwind CSS, Bootstrap, Ant
          Design, Chakra UI, and Syncfusion UI. My backend knowledge includes Node.js,
          Express.js, MongoDB, MySQL, and PHP — making me well-equipped to build
          full-stack solutions with a design-first approach.
        </p>

        <div className="grid grid-cols-3 gap-4 max-w-lg mx-auto mb-10">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-gray-50 rounded-2xl py-4 px-2 shadow-sm border border-gray-100"
            >
              <p className="text-2xl md:text-3xl font-extrabold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                {stat.value}
              </p>
              <p className="text-[11px] md:text-xs font-medium text-gray-600 mt-1">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {skills.map((skill) => (
            <span
              key={skill}
              className="px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-gray-50 text-gray-800 shadow-sm border border-gray-100 hover:bg-white hover:shadow-md hover:-translate-y-0.5 transition"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
